import { FetchFn, SiteAssetsClientTopology, SiteAssetsManifests, SiteAssetsModuleName } from '@wix/thunderbolt-symbols'
import { ModuleFetcherRequest, SiteAssetsModuleFetcher } from '@wix/site-assets-client'
import { createPromise, loadRequireJS, loadScriptWithRequireJS } from '@wix/thunderbolt-commons'

type Topology = {
	pathInFileRepo: SiteAssetsClientTopology['pathOfTBModulesInFileRepoForFallback']
	fileRepoUrl: SiteAssetsClientTopology['fileRepoUrl']
}
const loadModule = (
	moduleName: SiteAssetsModuleName,
	manifests: SiteAssetsManifests,
	{ pathInFileRepo, fileRepoUrl }: Topology,
	fetchFn: FetchFn,
	env: 'web' | 'webWorker' = 'web',
	cachedModules: { [moduleUrl: string]: any } = {}
) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	return async (module: object = {}, exports: object = {}) => {
		const pathInBeckyRepo = `${pathInFileRepo}${env === 'webWorker' ? 'site-assets-webworker/' : ''}`
		if (env === 'web') {
			const webpackRuntimeBundleHash: string = manifests[env].webpackRuntimeBundle
			const webpackRuntimeBundleUrl = `${fileRepoUrl}/${pathInBeckyRepo}webpack-runtime.${webpackRuntimeBundleHash}.js`
			if (cachedModules[webpackRuntimeBundleUrl]) {
				await cachedModules[webpackRuntimeBundleUrl]
			} else {
				const { promise: webpackRuntimePromise, resolver: webpackRuntimeResolver } = createPromise()
				cachedModules[webpackRuntimeBundleUrl] = webpackRuntimePromise
				const webpackRuntimeBundleScriptResponse = await fetchFn(webpackRuntimeBundleUrl)
				const webpackRuntimeBundleScript = await webpackRuntimeBundleScriptResponse.text()
				// eslint-disable-next-line no-eval
				eval(webpackRuntimeBundleScript)
				// @ts-ignore
				webpackRuntimeResolver()
			}
		}

		const moduleHash: string = manifests[env].modulesToHashes[moduleName]
		const moduleFileUrl = `${fileRepoUrl}/${pathInBeckyRepo}${moduleName}.${moduleHash}.js`
		if (cachedModules[moduleFileUrl]) {
			return cachedModules[moduleFileUrl]
		} else {
			const { promise: modulePromise, resolver: moduleResolver } = createPromise()
			cachedModules[moduleFileUrl] = modulePromise
			const moduleFileResponse = await fetchFn(moduleFileUrl)
			const moduleFileScript = await moduleFileResponse.text()
			// eslint-disable-next-line no-eval
			eval(moduleFileScript)
			// @ts-ignore
			moduleResolver(module.exports.default)
			// @ts-ignore
			return cachedModules[moduleFileUrl]
		}
	}
}

const loadDataFixersModule = (
	moduleName: string,
	version: string,
	moduleRepoUrl: string,
	env: 'web' | 'webWorker' = 'web',
	fetchFn: FetchFn
) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	return async (module: object = {}, exports: object = {}) => {
		const santaDataFixerModuleFileUrl = (() => {
			const santaDataFixerModuleSuffix = env === 'web' ? 'thunderbolt' : 'thunderbolt-webworker'

			if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
				// use hardcoded version that includes thunderbolt dedicated build
				return `${moduleRepoUrl}/@wix/${moduleName}@${version}/dist/${moduleName}-${santaDataFixerModuleSuffix}.js`
			} else {
				return `${moduleRepoUrl}/@wix/${moduleName}@${version}/dist/${moduleName}-${santaDataFixerModuleSuffix}.min.js`
			}
		})()

		if (env === 'web') {
			await loadRequireJS(window, moduleRepoUrl)
			return loadScriptWithRequireJS(santaDataFixerModuleFileUrl)
		} else {
			// TODO: handle failure
			const dataFixerScript = await fetchFn(santaDataFixerModuleFileUrl).then((resp) => resp.text())

			// eslint-disable-next-line no-eval
			eval(dataFixerScript)

			// @ts-ignore
			return module.exports
		}
	}
}

export const clientModuleFetcher = (
	fetchFn: FetchFn,
	{ fileRepoUrl, pathOfTBModulesInFileRepoForFallback, moduleRepoUrl }: SiteAssetsClientTopology,
	manifests: { thunderbolt: SiteAssetsManifests },
	env: 'web' | 'webWorker' = 'web'
): SiteAssetsModuleFetcher => {
	const cachedModules: { [moduleUrl: string]: any } = {}
	return {
		fetch: async <T>(request: ModuleFetcherRequest): Promise<T> => {
			const { module, version } = request

			if (module.startsWith('thunderbolt-')) {
				const topology: Topology = {
					fileRepoUrl,
					pathInFileRepo: pathOfTBModulesInFileRepoForFallback,
				}
				return await loadModule(
					module as SiteAssetsModuleName,
					manifests.thunderbolt,
					topology,
					fetchFn,
					env,
					cachedModules
				)()
			} else {
				return await loadDataFixersModule(module, version, moduleRepoUrl, env, fetchFn)()
			}
		},
	}
}
